import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69c876e1c3f848001379d3d0/citytprm/src/app/contracts/components/ContractModule.tsx");
